export default "__VITE_ASSET__Bue$QPb$__"